<template>
    <div class="pb-4">
        <h3 class="font-bold text-xl pb-4">新的要保人資料</h3>
        <CaseBox :caseBox="applicantData"></CaseBox>
    </div>
</template>
<script setup>

import CaseBox from '@/components/cloudCounter/CaseBox.vue'

import { defineProps, onMounted, ref, toRef } from 'vue';
import AplCatlCode from '@/json/aplCatlCode';

const applicantData = ref({})

const props = defineProps({
    result: {
        type: Object,
        required: true,
    },
});
const code = ref(AplCatlCode.APPLICANT_CHANGE);
const data = toRef(props, 'result');

const { after, } = data.value;

const convertTel = (telAreaCode, tel, telExt) => {
    let returnTel = ''

    if (telAreaCode && tel) {
        returnTel = `${telAreaCode}-${tel}`
    }
    if (telExt) {
        returnTel = `${returnTel} #${telExt}`
    }

    return returnTel;
}

const initData = () => {
    data.value.showData = {
        applicantDataInfo: after.applicantDataInfo,
        profession: after.professionInfo,
        connectionInfo: {
            applicantInfoAddress: `${after?.applicantInfo?.city}${after?.applicantInfo?.cityArea}${after?.applicantInfo?.address}`,
            applicantInfoTel: `${after?.applicantInfo?.telAreaCode}${after?.applicantInfo?.tel}`,
            chargeInfoAddress: `${after?.chargeInfo?.city}${after?.chargeInfo?.cityArea}${after?.chargeInfo?.address}`,
            chargeInfoTel: `${after?.chargeInfo?.telAreaCode}${after?.chargeInfo?.tel}`,
            mobile: after.mobile,
            email: after.email,
        },
    };

    let formData = {
        boxList: [{
            title: '要保人基本資料',
            list: [
                { key: '姓名', value: after?.applicantDataInfo?.name, },
                { key: '身分證字號', value: after?.applicantDataInfo?.id, },
                { key: '國籍', value: after?.applicantDataInfo?.country, },
                { key: '出生日期', value: after?.applicantDataInfo?.birthday, },
                { key: '與被保險人的關係', value: after?.applicantDataInfo?.relation, },
            ]
        },
        {
            title: '職業內容',
            list: [
                { key: '服務單位', value: after?.professionInfo?.unit, },
                { key: '營業性質', value: after?.professionInfo?.nature, },
                { key: '職位', value: after?.professionInfo?.position, },
                { key: '工作內容', value: after?.professionInfo?.content, },
                { key: '職業代碼', value: after?.professionInfo?.code, },
                { key: '兼職工作內容', value: after?.professionInfo?.partTimeContent, },
                { key: '兼職代碼', value: after?.professionInfo?.partTimeCode, },
            ]
        },
        {
            title: '要保人聯絡資訊',
            list: [
                { key: '收費地址', value: `${after?.chargeInfo?.city}${after?.chargeInfo?.cityArea}${after?.chargeInfo?.address}`, },
                { key: '收費地址市話', value: convertTel(after?.chargeInfo?.telAreaCode, after?.chargeInfo?.tel, after?.chargeInfo?.telExt), },
                { key: '住所（戶籍地址）', value: `${after?.applicantInfo?.city}${after?.applicantInfo?.cityArea}${after?.applicantInfo?.address}`, },
                { key: '住所（戶籍地址）市話', value: convertTel(after?.applicantInfo?.telAreaCode, after?.applicantInfo?.tel, after?.applicantInfo?.telExt), },
                { key: '行動電話', value: after.mobile, },
                { key: 'E-mail', value: after.email, },
            ]
        },]
    }

    formData.boxList = formData.boxList.map(item => {
        item.list = item.list.filter(box => {
            if (!box.value) {
                return false;
            }
            return true;
        });
        return item;
    });

    applicantData.value = formData;
    getRiderCancellation();

};

const getRiderCancellation = () => {
    const message = data.value?.exemptRiderList.map(p => {
        return `【${p.name}(${p.item})】`;
    }).join('、');
    if (message) {
        data.value.showData.riderCancellation = {
            hint: `取消${message}`,
        };
    }
};
onMounted(() => {
    initData();
});

</script>

<style scoped lang="scss"></style>
